import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManagePanelService {
  private _isPreview = new BehaviorSubject<boolean>(true);
  private _isFormDirty = new BehaviorSubject<boolean>(false);
  private _dataChanged = new Subject<void>();

  defaultRestored = new Subject<void>();

  isPreview$ = this._isPreview.asObservable();
  isFormDirty$ = this._isFormDirty.asObservable();
  dataChanged$ = this._dataChanged.asObservable();

  notifyDataChanged() {
    this._dataChanged.next();
  }

  setIsPreview(isPreview: boolean) {
    this._isPreview.next(isPreview);
  }

  setFormDirty(isDirty: boolean) {
    this._isFormDirty.next(isDirty);
  }

  reset(): void {
    this._isPreview.next(true);
    this._isFormDirty.next(false);
  }
}
